<template>
  <v-autocomplete
    v-model="VALOR_SELECIONADO"
    label="Tipos de produto"
    outlined
    hide-details
    :items="tipos_produtos"
    multiple
    small-chips
  >
    <template #prepend-item>
      <v-list-item v-if="VALOR_SELECIONADO.length === tipos_produtos.length" class="py-2" @click="VALOR_SELECIONADO = []">
        <v-icon color="primary" class="ml-2">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
        @click="VALOR_SELECIONADO = Helpers.arrayColumn(tipos_produtos, 'value')"
      >
        <v-icon v-if="VALOR_SELECIONADO.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'SysTiposProdutoAutocomplete',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: Array,
  },
  emits: ['update:modelValue'],
  data: () => ({
    tipos_produtos: [
      { value: 'PRODUTOS_NAO_COMBINADOS', text: 'Produtos não combinados' },
      { value: 'PRODUTOS_COMBINADOS', text: 'Produtos combinados' },
    ]
  }),
  computed: {
    VALOR_SELECIONADO: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      },
    }
  }
}
</script>
